import { UILAB_NG_MAT_COMPONENTS_PACKAGE } from '../../shared/constants/dependencies.constants';

export const COMPONENT_EXAMPLES_CONSTANTS = {
    PACKAGE_NAME: UILAB_NG_MAT_COMPONENTS_PACKAGE,
    GET_STARTED_LINK: '/build/components/getting-started',
    STYLING_PACKAGE_LINK:
        'https://dev.azure.com/AVEVA-VSTS/UX/_artifacts/feed/UX/Npm/@uilab%2Fstyling/',
    NG_MAT_COMPONENTS_PACKAGE_LINK:
        'https://dev.azure.com/AVEVA-VSTS/UX/_artifacts/feed/UX/Npm/@uilab%2Fng-mat-components/',
    ANGULAR_MATERIAL_THEME_PACKAGE_LINK:
        'https://dev.azure.com/AVEVA-VSTS/UX/_artifacts/feed/UX/Npm/@uilab%2Fangular-material-theme/',
    STORYBOOK_BASE_URL: 'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net',
    AZURE_DEVOPS_BASE_URL:
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components',
} as const;
